import React from 'react';
import {connect} from 'react-redux';
import RowPayroll from './RowPayroll.jsx';
import style from './PayrollList.css';

const PayrollList = (props) => (
    <div className="table-responsive">
        <table className={`table ${style.PayrollList}`}>
            <thead>
            <tr>
                <th className={style.PayrollList__thRecruiter}>Captador</th>
                <th className={style.PayrollList__thDate}>Desde</th>
                <th className={style.PayrollList__thDate}>Hasta</th>
                <th className={style.PayrollList__thGenerationDate}>Hora Creación</th>
                <th className={style.PayrollList__thRecruiter}>Creado Por</th>
                <th className={style.PayrollList__thTotalPartners}>Total Op.</th>
                <th className={style.PayrollList__thTotal}>Total</th>
                <th className={style.PayrollList__thStatus}></th>
                <th className={style.PayrollList__thOption}></th>
            </tr>
            </thead>
            <tbody>
            {props.payrolls.length > 0 ?
                props.payrolls.map((payroll) => (
                    <RowPayroll payroll={payroll} key={payroll.payrollId} deletePayroll={props.deletePayroll} getPayrolls={props.getPayrolls}/>
                ))
                :
                <td colSpan="9" style={{textAlign: "center"}}><b>No se encontraron nóminas de pago</b></td>
            }
            </tbody>
        </table>    
    </div>
);

export default PayrollList;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/PayrollList.jsx